import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
	SdfIcon,
	SdfButton,
	SdfLink
} from '@synerg/react-components';
import { withSession } from '../session';
import clientConfig from '../../config';
import BrandedDeveloper from '../../images/branded-developer.png';

function SsoLoginPage({ session = {} }) {
	const history = useHistory();
	const [ nodeEnv, setNodeEnv ] = useState( import.meta.env.VITE_ENVIRONMENT || 'PROD');

	const goToFedSSO = () => {
		window.location.href = `${clientConfig.appDirector[nodeEnv]}/setDssCookie`;
	};

	useEffect(() => {
		async function fetchSession() {
			try {
				const { data } = await axios(`${import.meta.env.VITE_ROOT_PATH}/api/login-session`);
				/* SSO login page should check if the session is active (user is logged in) and redirect to projects page. */
				const redirectUrl = `${import.meta.env.VITE_ROOT_PATH}/projects`;
				if (data.session) {
					history.push(redirectUrl);
				}
				if (data.env) {
					setNodeEnv(data.env);
				}
			} catch(e) {

			}
		}
		fetchSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (<div>
		<div className="px-6 text-6xl text-brand-primary">
			<SdfIcon icon={'brand-adp'} />
		</div>
		<div className="flex ml-24 pb-32">
			<div className="flex-1 bg-action-default-100 p-24 pb-0" style={{ height: '585px' }}>
				<h1 className="text-6xl m-0 pb-stack-2xs flex flex-col">
					<span>Welcome to</span>
					<span>Marketplace</span>
					<div className="w-16 p-1 bg-action-default-500 my-8 inline-block"></div>
				</h1>
				<div className="flex justify-center">
					<img src={ BrandedDeveloper } alt="Login Banner" style={{ width: '490px' }} />
				</div>
			</div>
			<div className="flex-1 min-h-xs flex flex-col text-center justify-center content-center flex-wrap">
				<h2 className="text-4xl my-2 -mt-20">Log In</h2>
				<h3 className="text-2xl my-2">
					<div>as an admin to</div>
					<div>Developer Self-Service</div>
				</h3>
				<div className="my-8">
					<SdfButton onClick={goToFedSSO} emphasis={"primary"} className="w-64">
						<span className="text-xl my-3 inline-block">Continue with SSO</span>
					</SdfButton>
				</div>
				<SdfLink href={`${clientConfig.baseUrl[nodeEnv]}/api/authenticate`} action="standard" className="text-lg mt-1 inline-block font-bold -mt-4 text-action-primary">or login with credentials</SdfLink>
			</div>
		</div>
	</div>);
}

export default withSession(SsoLoginPage);
